import * as React from 'react';

import {Button, Menu, MenuItem, MenuTrigger, MenuGroup} from '@sail/ui';

/* eslint-disable no-alert */

const basic = {
  rendered: (
    <MenuTrigger>
      <Button>Menu</Button>
      <Menu slot="menu">
        <MenuItem>Edit</MenuItem>
        <MenuItem>Copy</MenuItem>
        <MenuItem>Paste</MenuItem>
      </Menu>
    </MenuTrigger>
  ),
  source: `<MenuTrigger>
  <Button>Menu</Button>
  <Menu slot="menu">
    <MenuItem>Edit</MenuItem>
    <MenuItem>Copy</MenuItem>
    <MenuItem>Paste</MenuItem>
  </Menu>
</MenuTrigger>`,
};

const items = {
  rendered: (
    <Menu aria-label="Menu">
      <MenuItem>Edit</MenuItem>
      <MenuItem disabled>Copy</MenuItem>
      <MenuItem>Paste</MenuItem>
    </Menu>
  ),
  source: `<Menu aria-label="Menu">
  <MenuItem>Edit</MenuItem>
  <MenuItem disabled>Copy</MenuItem>
  <MenuItem>Paste</MenuItem>
</Menu>`,
};

const groups = {
  rendered: (
    <MenuTrigger>
      <Button>Edit</Button>
      <Menu slot="menu">
        <MenuGroup title="Actions">
          <MenuItem>Duplicate</MenuItem>
          <MenuItem disabled>Edit</MenuItem>
          <MenuItem>Cancel</MenuItem>
        </MenuGroup>
        <MenuGroup title="Connections">
          <MenuItem>View customer</MenuItem>
          <MenuItem>View subscription</MenuItem>
        </MenuGroup>
      </Menu>
    </MenuTrigger>
  ),
  source: `<MenuTrigger>
  <Button>Edit</Button>
  <Menu slot="menu">
    <MenuGroup title="Actions">
      <MenuItem>Duplicate</MenuItem>
      <MenuItem disabled>Edit</MenuItem>
      <MenuItem>Cancel</MenuItem>
    </MenuGroup>
    <MenuGroup title="Connections">
      <MenuItem>View customer</MenuItem>
      <MenuItem>View subscription</MenuItem>
    </MenuGroup>
  </Menu>
</MenuTrigger>`,
};

const events = {
  rendered: (
    <Menu
      aria-label="Menu"
      onAction={(key) => alert(`Item ${key} was pressed.`)}
    >
      <MenuGroup title="Actions">
        <MenuItem key="duplicate">Duplicate</MenuItem>
        <MenuItem key="edit">Edit</MenuItem>
        <MenuItem key="cancel">Cancel</MenuItem>
      </MenuGroup>
      <MenuGroup title="Connections">
        <MenuItem
          key="View customer"
          onAction={() => alert(`View customer was pressed.`)}
        >
          View customer
        </MenuItem>
        <MenuItem key="View subscription">View subscription</MenuItem>
      </MenuGroup>
    </Menu>
  ),
  source: `<Menu
  aria-label="Menu"
  onAction={(key) => alert(\`Item \${key} was pressed.\`)}
>
  <MenuGroup title="Actions">
    <MenuItem key="duplicate">Duplicate</MenuItem>
    <MenuItem key="edit">Edit</MenuItem>
    <MenuItem key="cancel">Cancel</MenuItem>
  </MenuGroup>
  <MenuGroup title="Connections">
    <MenuItem
      key="View customer"
      onAction={() => alert(\`View customer was pressed.\`)}
    >
      View customer
    </MenuItem>
    <MenuItem key="View subscription">View subscription</MenuItem>
  </MenuGroup>
</Menu>`,
};

const trigger = {
  rendered: (
    <MenuTrigger>
      <Button>Menu</Button>
      <Menu slot="menu">
        <MenuGroup title="Actions">
          <MenuItem>Duplicate</MenuItem>
          <MenuItem disabled>Edit</MenuItem>
          <MenuItem>Cancel</MenuItem>
        </MenuGroup>
        <MenuGroup title="Connections">
          <MenuItem>View customer</MenuItem>
          <MenuItem>View subscription</MenuItem>
        </MenuGroup>
      </Menu>
    </MenuTrigger>
  ),
  source: `<MenuTrigger>
  <Button>Menu</Button>
  <Menu slot="menu">
    <MenuGroup title="Actions">
      <MenuItem>Duplicate</MenuItem>
      <MenuItem disabled>Edit</MenuItem>
      <MenuItem>Cancel</MenuItem>
    </MenuGroup>
    <MenuGroup title="Connections">
      <MenuItem>View customer</MenuItem>
      <MenuItem>View subscription</MenuItem>
    </MenuGroup>
  </Menu>
</MenuTrigger>`,
};

export const MenuExamples = {basic, items, groups, events, trigger};
